import { PropsWithChildren } from 'react'
import { sendMessageToRoot } from 'screens/TabRoot/utils'
import { useIsPwa } from 'utils/isPwa'
import { useModalStore } from './stores/useModalStore'

const OpenLinkModal = (props: PropsWithChildren<any>) => {
  return (
    <div>
      <p>Your browser settings are blocking this doc from opening in a new window.</p>
      <p>
        <a
          href={props.url}
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            props.closeModal()
          }}
        >
          Click here to open the doc.
        </a>
      </p>
    </div>
  )
}

/**
 * Returns function to open a new window with the given URL.
 * If the new window can't be created, it will show a modal with a link to open the blocked page manually.
 * Initially created to fix Safari from blocking popups.
 */
const useOpenWindowSafely = () => {
  const { openModal } = useModalStore()
  const isPwa = useIsPwa()

  if (isPwa) {
    return (url: string) => sendMessageToRoot({ type: 'AddTab', url, title: 'Blaze' })
  }

  return (url: string) => {
    const newWindow = window.open() as any
    try {
      newWindow.focus()
      newWindow.location = url

      return newWindow
    } catch (e) {
      openModal(OpenLinkModal, {
        modalOptions: { url },
        modalProps: {
          title: 'Attention',
          footer: null,
          url: url,
        },
      })
    }
  }
}

// To use outside React components.
export const openWindowSafely = (url: string) => {
  const { openModal } = useModalStore.getState()

  const newWindow = window.open() as any
  try {
    newWindow.focus()
    newWindow.location = url

    return newWindow
  } catch (e) {
    openModal(OpenLinkModal, {
      modalOptions: { url },
      modalProps: {
        title: 'Attention',
        footer: null,
      },
    })
  }
}

export default useOpenWindowSafely
